export default __webpack_public_path__ + "static/media/Träslöjd7.46972c4a.jpeg";